/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { MegaMenuArticleContainer, MegaMenuArticleImg, MegaMenuArticleText } from '../MegaMenuStyles';
import { LazyLink } from '../../../../../../../../slices/atoms';

const navigationTracking = (name, category) => {
  window.analytics.track('Web Interaction', {
    action: 'click',
    category,
    name,
  });
};

const ArticleLinks = data =>
  // Mapping through the Community Mega Menu data
  data.map(item => (
    <MegaMenuArticleContainer
      url={item.featured_articles_link && item.featured_articles_link.url}
      key={item.featured_articles_text}
      renderAs={LazyLink}
      onClick={() => {
        navigationTracking(item.featured_articles_tracking_name, item.featured_articles_tracking_category);
      }}
    >
      <MegaMenuArticleImg
        src={item.featured_articles_image.url}
        alt={item.featured_articles_image.alt || item.featured_articles_text || 'Article image'}
      />
      <MegaMenuArticleText> {item.featured_articles_text}</MegaMenuArticleText>
    </MegaMenuArticleContainer>
  ));

export default ArticleLinks;

ArticleLinks.propTypes = {
  data: PropTypes.node.isRequired,
};
